import Vue from 'vue'
import * as types from '../mutation-types'
import helpers from '@/util/helpers'

// initial state
const state = {
  topics: [],
  topicsPagination: {},
  topic: {}
}

// getters
const getters = {
  topics: state => state.topics,
  topicsPagination: state => state.topicsPagination,
  topic: state => state.topic
}

// actions
const actions = {
  getTopics({ state, commit }, args) {
    return Vue.axios.get(`/topics/`, {
      params: args.params,
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_TOPIC_LIST, { response })
    })
  },
  createTopic({ state, commit }, args) {
    return Vue.axios.post(
      `/topics/`,
      args
    ).then((response) => {
      commit(types.RECEIVE_TOPIC, { response })
    })
  },
  getTopic({ state, commit }, args) {
    return Vue.axios.get(`/topics/${args.id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_TOPIC, { response })
    })
  },
  saveTopic({ state, commit }, args) {
    return Vue.axios.put(
      `/topics/${state.topic.id}/`, state.topic, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_TOPIC, { response })
    })
  },
  deleteTopic({ state, commit }, args) {
    return Vue.axios.delete(`/topics/${args.id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_TOPIC, { response })
    })
  },
  uploadTopicCover({ state, commit }, args) {
    return Vue.axios.post(`/topics/${args.id}/upload-cover/`,
      args.formEncodedData,
      {
        headers: args.headers || null
      }
    )
      .then(function (response) {
        commit(types.RECEIVE_TOPIC, { response })
      })
  },
  addTopicStory({ state, commit }, args) {
    return Vue.axios.post(`/topics/${args.topic_id}/stories/${args.story_id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.UPDATE_TOPIC_VALUE, { stories: response.data.results.stories })
    })
  },
  deleteTopicStory({ state, commit }, args) {
    return Vue.axios.delete(`/topics/${args.topic_id}/stories/${args.story_id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.UPDATE_TOPIC_VALUE, { stories: response.data.results.stories })
    })
  }
}

// mutations
const mutations = {
  [types.RECEIVE_TOPIC_LIST](state, { response }) {
    state.topics = response.data.results
    state.topicsPagination = helpers.pagination(response.headers)
  },
  [types.RECEIVE_TOPIC](state, { response }) {
    state.topic = response.data.results
  },
  [types.UPDATE_TOPIC_VALUE](state, value) {
    state.topic = Object.assign(state.topic, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}